module.exports = __webpack_public_path__ + "static/session-cc941a2f74e3e4fed3dd52d97c56b492.png";